import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHero } from '@/components/ui-bits';
import { Reveal } from '@/components/motion';
import { OrnamentLeaf } from '@/components/Ornaments';
import { getWithRetry } from '@/lib/api';

export default function Blog() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    getWithRetry(`/blog?lang=${lang}`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, [lang]);

  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow={t('nav.blog')}
        title={t('blog.title')}
        subtitle={t('blog.subtitle')}
        ornament={<OrnamentLeaf className="hidden md:block absolute right-6 top-16 w-72 text-terracotta/20" />}
      />

      <section className="px-5 md:px-10 pb-24">
        <div className="max-w-[1280px] mx-auto">
          {posts === null && <p className="text-textDark/60 text-xl">{t('blog.loading')}</p>}
          {posts && posts.length === 0 && <p className="text-textDark/60 text-xl">{t('blog.empty')}</p>}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts && posts.map((post, i) => (
              <Reveal key={post.post_id} delay={(i % 3) * 0.08}>
                <Link to={`/${lang}/blog/${post.slug}`} data-testid={`blog-card-${i}`} className="group block bg-card rounded-3xl overflow-hidden border border-terracotta/10 h-full hover:border-terracotta/30 transition-colors">
                  <div className="overflow-hidden h-56">
                    <img src={post.cover_image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-7">
                    <h2 className="font-serif text-2xl text-textDark leading-snug mb-3 group-hover:text-terracotta transition-colors">{post.title}</h2>
                    <p className="text-textDark/70 line-clamp-3 mb-4">{post.excerpt}</p>
                    <span className="text-terracotta font-semibold">{t('common.readMore')} →</span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
